import type { ItineraryEventType } from "@/types/itinerary"
import type { Place } from "@/types/place"
import { cn } from "cn"

import { EntityIcon } from "@/components/entity-icon"
import { Photo } from "@/components/ui/photo"
import { eventColorPair } from "./itinerary-utils"

export function itineraryEventToastLeading({
  action,
  place,
  iconType,
  title,
}: {
  action: "add" | "remove" | string
  place?: Place
  iconType?: ItineraryEventType
  title?: string
}) {
  const photoUrl = place?.photos?.[0]?.url

  if (!photoUrl && !iconType) return null

  return (
    <span
      className={cn(
        "relative mr-1 flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg",
        !photoUrl && iconType && title && eventColorPair(title),
        action === "remove" && "opacity-30"
      )}
    >
      {photoUrl ? (
        <Photo
          src={photoUrl}
          width="sm"
          className="absolute inset-0 size-full"
          alt=""
        />
      ) : iconType ? (
        <EntityIcon type={iconType} size={16} />
      ) : null}
    </span>
  )
}

export function streamedItineraryEventToastLeading({
  eventType,
  photoUrl,
  title,
}: {
  eventType: ItineraryEventType
  photoUrl?: string
  title: string
}) {
  return (
    <span
      className={cn(
        "relative mr-1 flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg",
        !photoUrl && eventColorPair(title)
      )}
    >
      {photoUrl ? (
        <Photo
          src={photoUrl}
          width="sm"
          className="absolute inset-0 size-full"
          alt=""
        />
      ) : (
        <EntityIcon type={eventType} size={16} />
      )}
    </span>
  )
}
